const POSITIONS = {
  TOP: "top",
  TOP_LEFT: "top-left",
  TOP_RIGHT: "top-right",
  BOTTOM: "bottom",
  BOTTOM_LEFT: "bottom-left",
  BOTTOM_RIGHT: "bottom-right"
};

export default POSITIONS;



// WEBPACK FOOTER //
// ./src/Positions.js